"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueToOptionRecordToOptions = exports.valueToLabelRecordToOptions = void 0;
function valueToLabelRecordToOptions(valueToLabelRecord) {
    return Object.entries(valueToLabelRecord).map(([value, label]) => ({ value, label }));
}
exports.valueToLabelRecordToOptions = valueToLabelRecordToOptions;
function valueToOptionRecordToOptions(valueToOptionRecord) {
    return Object.entries(valueToOptionRecord).map(([value, option]) => ({ ...option, value }));
}
exports.valueToOptionRecordToOptions = valueToOptionRecordToOptions;
//# sourceMappingURL=util.js.map